export default "__VITE_ASSET__Ch7ezWMo__"